import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { isAfter, isBefore, isEqual, parseISO } from "date-fns";

import StartUpMessagePopUp from "./StartUpMessagePopup";
import audienceHelper from "../../components/utils/AudienceHelper";
import { RedirectHelper } from "../../config/utils/RedirectHelper";

const StartUpMessage = (props) => {
  const { userHelper, dataHelper, history, config, createContactAction } =
    props;

  const { redirectTo } = RedirectHelper();
    
  const [startUpMessage, setStartUpMessage] = useState({});
  const [openStartUpMessage, setOpenStartUpMessage] = useState(false);

  const { userViewedStartUpMessages, userAudience, userData } = useSelector(
    ({ userData, audienceTypes }) => ({
      userData: userData.userData,
      userAudience: audienceTypes.audienceTypes,
      userViewedStartUpMessages: userData.viewedStartUpMessages,
    })
  );

  const viewedMessages = useMemo(() => {
    const isLoggedIn = userData && Object.keys(userData)?.length > 0;

    if (isLoggedIn) {
      return userViewedStartUpMessages ?? null;
    } else {
      const stored =
        localStorage.getItem("CRUViewedStartUpMessagesStorage") || "[]";
      return stored ? JSON.parse(stored) : null;
    }
  }, [userData, userViewedStartUpMessages]);

  const handleCloseStartUpMessage = async (
    action = {},
    startUpMessage,
    type
  ) => {
    setOpenStartUpMessage(false);
    const isLoggedIn = userData && Object.keys(userData)?.length > 0;

    if (isLoggedIn) {
      userHelper?.setViewedStartupMessage(startUpMessage, type);
      const contactAction = {
        action: "ACTION_VIEW_STARTUP_MESSAGE",
        startUpMessage: startUpMessage?.Id,
        value: type,
      };

      if (
        startUpMessage?.RedirectAppScreen__c === "MatchDay" &&
        startUpMessage?.RedirectId__c
      ) {
        contactAction.eventId = startUpMessage?.RedirectId__c;
      }

      await createContactAction(contactAction);
    }

    const stored = localStorage.getItem("CRUViewedStartUpMessagesStorage");
    const current = stored ? JSON.parse(stored) : [];
    const updated = [...new Set([...current, startUpMessage?.Id])];
    localStorage.setItem(
      "CRUViewedStartUpMessagesStorage",
      JSON.stringify(updated)
    );

    if (action?.screen === "Webview") {
      window.open(action?.params?.url, "_blank");
    } else if (action?.screen === "AppScreen") {
      redirectTo(
        startUpMessage.RedirectAppScreen__c,
        startUpMessage.RedirectId__c
      );
    }
  };

  const handleType = useMemo(() => {
    if (!openStartUpMessage) return null;

    switch (startUpMessage.ScreenType__c) {
      case "FullScreen":
        return null;
      // return (
      //   <StartUpMessageFullScreen
      //     open={openStartUpMessage}
      //     message={startUpMessage}
      //     handleClose={handleCloseStartUpMessage}
      //     createViewRecord={createViewRecord}
      //   />
      // );
      case "Pop-up":
        return (
          <StartUpMessagePopUp
            open={openStartUpMessage}
            message={startUpMessage}
            handleClose={handleCloseStartUpMessage}
            config={config}
          />
        );
      case "Bottom Message":
        return null;
      // return (
      //   <StartUpMessageBottom
      //     message={startUpMessage}
      //     handleClose={handleCloseStartUpMessage}
      //     createViewRecord={createViewRecord}
      //   />
      // );
      default:
        return null;
    }
  }, [startUpMessage, openStartUpMessage, config]);

  const hasStartDate = (today, startDate) =>
    startDate &&
    (isAfter(today, parseISO(startDate)) ||
      isEqual(today, parseISO(startDate)));

  const hasEndDate = (today, endDate, targetGroup) =>
    endDate &&
    (isBefore(today, parseISO(endDate)) ||
      (targetGroup &&
        userAudience[targetGroup]?.periodEndDate &&
        isBefore(today, parseISO(userAudience[targetGroup].periodEndDate))));

  const isWellConfigured = (message) =>
    message.ScreenType__c === "Bottom Message" ||
    (message.ScreenType__c !== "Bottom Message" &&
      message.StartUpMessageItems__r?.records?.length);

  const sortStartUpMessages = (startUpMessages) => {
    const priorityObj = {};
    const result = [];

    startUpMessages.forEach((item) => {
      if (!priorityObj[item.Priority__c]) {
        priorityObj[item.Priority__c] = [];
      }
      priorityObj[item.Priority__c].push(item);
    });

    for (let item in priorityObj) {
      result.push(
        priorityObj[item].sort(
          (a, b) => parseISO(a.StartDateTime__c) - parseISO(b.StartDateTime__c)
        )
      );
    }

    return result.flat();
  };

  const loadData = async () => {
    const today = new Date();

    const messages = await dataHelper.getStartupMessages(
      viewedMessages,
      userAudience
    );

    const startUpMessages = messages
      .filter(
        (message) =>
          hasStartDate(today, message.StartDateTime__c) &&
          hasEndDate(today, message.EndDateTime__c, message.TargetGroup__c) &&
          isWellConfigured(message) &&
          !(viewedMessages && viewedMessages?.includes(message.Id))
      )
      .sort((a, b) => b.Priority__c - a.Priority__c);

    if (!startUpMessages.length) return;

    const sortedStartUpMessages = sortStartUpMessages(startUpMessages);

    setStartUpMessage(sortedStartUpMessages[0]);
    setOpenStartUpMessage(true);
  };

  useEffect(() => {
    if (userAudience && viewedMessages) loadData();
  }, [viewedMessages, userAudience, dataHelper]);

  return <>{handleType}</>;
};

export default StartUpMessage;
